// SPDX-License-Identifier: AGPL-3.0-or-later

import {createElementHost} from '@app/features/holiday/utils/createElementHost';

export const HOLIDAY_SCARE_HOST_SELECTOR = '[data-flx="holiday.holiday-layer.scare-host"]';

const scareHost = createElementHost();

/** `from` guards against a stale unmount clearing a host that a newer mount already claimed. */
export const setHolidayScareHost = scareHost.set;
export const getHolidayScareHost = scareHost.get;
export const subscribeHolidayScareHost = scareHost.subscribe;

/** Keeps the scare box off the composer, which sits below the messages well in the same layout. */
export function setHolidayScareComposerInset(heightPx: number | null): void {
	scareHost.setCssVar('--scare-inset-bottom', heightPx);
}
